// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1E0OD","title":"styles_title__1RZEu"};